<template>
  <main role="main" class="py-4">
    <b-container fluid="lg" class="mb-3">
      <b-button class="ml-4" variant="outline-primary" to="/location/new" v-if="isUserAdmin()"
        style="margin:4px!important;float:right;margin-right:0px;">
        <b-icon icon="plus"></b-icon> {{ $t("createNew") }}
      </b-button>
      <div class="d-flex flex-row align-items-center justify-content-between mb-4">

        <h4 class="m-0">{{ $t("regionAdminList") }}</h4>

      </div>

      <b-form class="d-flex flex-row align-items-center mb-3" @submit.prevent="debouncedOnFilterFormSubmit">
        <div class="flex-shrink-0 mr-3">{{ $t("search") }}</div>
        <b-form-input type="search" v-model="searchText" minlength="2" maxlength="50" :placeholder="$t('tukhoatimkiem')"
          class="mr-5" style="width:40%!important" @keyup.enter="debouncedOnFilterFormSubmit"/>
        <b-button @click="debouncedRegionSearch()" class="flex-shrink-0" variant="primary">{{ $t("search") }}</b-button>

      </b-form>
     
      <b-table ref="table" :items="tableItemProvider" class="goicuoctable" hover primary-key="id" :fields="tableFields" show-empty
        :per-page="itemsPerPage" :current-page="currentPage" :filter="searchText">
        <template v-slot:table-busy>
          <div class="text-center text-secondary py-4">{{ $t("loadingData") }}</div>
        </template>
        <template v-slot:empty>
          <div class="text-center text-secondary py-4">{{ $t("noData") }}</div>
        </template>
        <template v-slot:cell(id)="data">
          {{ data.item.id }}
        </template>
        <template v-slot:cell(name)="data">
            {{ data.item.name }}  
        </template>

        <template v-slot:cell(subscriptions)="data">
          <div v-if="data.item.subscriptions && data.item.subscriptions.length > 0">
            <div class="pckList">
              <div v-for="(sub, i) in data.item.subscriptions" v-bind:key="sub.subscriptionPlanId">
                <div  @click="showPackageDetailModal(data.item.subscriptions)"  class="pckItem focusItem"                  
                  v-if="i < 10"
                  v-b-tooltip.hover.bottom.html = "getTooltip(sub)" >                  
                  {{ sub.name }}
                </div>

                <div class="pckItemMore" style="list-style:none!important;width:100%" v-if="i == 10">
                  <a style="color:#004f9e;cursor: pointer;margin-top:15px;font-size: 15px"
                    @click="showPackageDetailModal(data.item.subscriptions)" v-b-modal:sub-modal>{{$t("viewmore")}} <i class="fa fa-angle-right" style="font-size: 14px" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="text-left text-secondary py-4" v-if="!data.item.subscriptions || data.item.subscriptions.length == 0">
            {{ $t("chuadangkygoicuoc") }}
          </div>
        </template>
        <template v-slot:cell(createAt)="data">
          {{ localDateFormat(data.item.createAt) }}
        </template>
        <template v-slot:cell(actions)="data">
          <template>
            <b-button :to="{ name: 'EditRegion', params: { id: data.item.id, initialRegion: data.item } }" variant="outline-primary" size="sm" class="mr-3">{{ $t("update") }}</b-button>
            <b-button variant="outline-danger" size="sm" @click="onClickDeleteRegion(data.item)">{{ $t("actionDelete")
            }}</b-button>
          </template>
          
        </template>
      </b-table>
    </b-container>

    <!--Modal hiển thị thêm thông tin gói cước của khu vực-->
    <b-modal id="sub-modal" dialog-class="region-dialog" modal-class="region-center"
      :title="$t('selectedPackageCount', { count: selectedSubs.length })" hide-footer no-close-on-backdrop>
      <b-row style="height:70vh;overflow-y:scroll">
        <b-col cols="12">
          <b-list-group class="contacts-list-group goicuoclist">
            <div v-if="!selectedSubs.length" class="py-3 text-center text-secondary">
              {{ $t("noData") }}
            </div>
            <b-list-group-item v-for="sub in selectedSubs" :key="sub.id || sub.subscriptionPlanId">
              <subscription-plan-item :plan="sub" />
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
    </b-modal>
  </main>
</template>

<style lang="scss">

.region-dialog {
  max-width: 900px !important;
  width:700px!important;
  margin: 0 !important;
}
td{

  vertical-align: middle!important;
}
.text-break
{
  vertical-align: middle!important;
}
.fullrow
{
  width:100%
}
.subtag {
  font-size: 9pt;
  padding: 2px 8px;
  border: 1px solid #dadada;
  margin-left: 5px;
  border-radius: 4px;
}

.region-center {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}


.pckList {

  list-style: none;
}

.pckItem {

  float: left;
  margin: 3px;
  padding: 7px 8px !important;
  border-radius: 10px;
  background-color: #E1EAF9;
  border: 1px solid #DEEAFF;
}
.focusItem{
  cursor: pointer;
  padding:0px;
  padding-top:3px;
  padding-bottom:3px;
  text-align:left
}

.pckItemMore {
  float: left;
  margin: 5px;
  padding: 7px 8px !important;
  color: #004f9e;
}

.radius-button {

  border-radius: 10px !important;
}
th td
{

  width:200px;
}
.customColumn
{

  width:600px;
  vertical-align: middle!important;
}

.detail-pack {
  font-size: 12px !important;
}
</style>

<script lang="ts">
import { Component, Ref } from 'vue-property-decorator';
import _ from "lodash";
import BaseComponent from "@/components/BaseComponent";
import { BvTableFieldArray } from "bootstrap-vue";
import { BTable, BvTableCtxObject, BvTableProviderPromiseResult } from "bootstrap-vue/src/components/table";

import * as regionService from "@/service/regionService";
import * as areaService from "@/service/areaService";
import { BounceTimes } from "@/views/enums/TimesNumbers";
import { ManagementType } from "@/views/enums/subscriptionAction";
import SubscriptionPlanItem from "@/views/location/components/SubscriptionPlanItem.vue";

/**
 * Màn hình Quản lý khu vực kinh doanh (/location).
 * Chức năng:
 * 1. Hiển thị danh sách các khu vực kinh doanh và các gói cước được gán tương ứng.
 * 2. Tìm kiếm khu vực theo tên.
 * 3. Xem chi tiết thông tin gói cước qua tooltip và modal xem thêm.
 * 4. Điều hướng sang tạo mới (/location/new) và cập nhật (/location/edit/:id).
 * 5. Xóa khu vực kinh doanh.
 */
@Component({
  components: {
    SubscriptionPlanItem
  }
})
export default class RegionManagement extends BaseComponent {
  /** Từ khóa tìm kiếm khu vực */
  searchText = "";
  /** Danh sách gói cước được chọn để hiển thị trong modal xem thêm */
  selectedSubs = [];
  /** Tham chiếu đến bảng bootstrap-vue */
  @Ref("table") table: BTable;

  /** Cấu hình các cột hiển thị trong bảng danh sách khu vực */
  get tableFields(): BvTableFieldArray {
    return [
      {
        key: "id",
        label: this.$t("regionCode").toString(),
        thClass: "text-nowrap",
        tdClass: "text-break",
        thStyle: { width: "100px" },
      },
      {
        key: "name",
        label: this.$t("regionName").toString(),
        thClass: "text-nowrap",
        tdClass: "text-break",
        thStyle: { width: "25%" },
      },
      {
        key: "subscriptions",
        label: this.$t("subscriptionPlan").toString(),
        thClass: "text-nowrap customColumn",
        thStyle: { width: "50%" },
      },
      {
        key: "createAt",
        label: this.$t("createdDate").toString(),
        thClass: "text-nowrap",
        tdClass: "text-nowrap",
      },
      {
        key: "actions",
        label: "",
        thClass: "text-nowrap",
        tdClass: "text-nowrap"
      }
    ];
  }

  /** Số lượng bản ghi trên một trang */
  itemsPerPage = 20;
  /** Trang hiện tại */
  currentPage = 1;
  /** Tổng số bản ghi */
  totalItems = 0;

  /** Hàm debounce tìm kiếm khi submit form lọc */
  debouncedOnFilterFormSubmit = _.debounce(() => {
    this.onFilterFormSubmit();
  }, BounceTimes.BOUNCETIMES);

  /** Làm mới bảng dữ liệu khi gửi form tìm kiếm */
  onFilterFormSubmit() {
    this.table.refresh();
  }

  /** Làm mới dữ liệu bảng */
  refreshData() {
    this.table.refresh();
  }

  /** Provider cung cấp dữ liệu phân trang cho b-table */
  async tableItemProvider(ctx: BvTableCtxObject): Promise<BvTableProviderPromiseResult> {
    const res = await regionService.getRegionList({
      page: ctx.currentPage,
      pageSize: this.itemsPerPage,
      q: this.searchText,
      name: ""
    });

    this.totalItems = 0;
    return res.data;
  }

  /** Mở modal xem danh sách chi tiết các gói cước của khu vực */
  showPackageDetailModal(data: any[]) {
    this.selectedSubs = data;
  }

  /** Hàm debounce khi bấm nút Tìm kiếm */
  debouncedRegionSearch = _.debounce(() => {
    this.onFilterFormSubmit();
  }, BounceTimes.BOUNCETIMES);

  /**
   * Xử lý xóa khu vực kinh doanh:
   * - Hiển thị hộp thoại xác nhận xóa với tên và mã khu vực.
   * - Gọi API xóa và refresh lại bảng dữ liệu.
   */
  async onClickDeleteRegion(region) {
    const modalMessage = this.$t("deleteRegionConfirm", { name: region.name, id: region.id }).toString();
    const confirmDelete = await this.$bvModal.msgBoxConfirm(modalMessage, {
      okVariant: 'danger',
      okTitle: this.$t("yes").toString(),
      cancelTitle: this.$t("no").toString(),
    });

    if (confirmDelete) {
      try {
        await areaService.deleteRegion(region.id);
        this.refreshData();
        this.toastSuccessDelay(this.$t("deleteRegionSuccessful").toString());
      } catch (e) {
        this.toastErrorOldType(e);
      }
    }
  }

  /**
   * Tạo nội dung tooltip đa ngôn ngữ hiển thị chi tiết khi rê chuột vào tag gói cước:
   * - Phân biệt giữa gói Cuộc họp đồng thời và gói Pool người tham dự.
   * - Giá và chu kỳ (ngày/tháng/năm).
   * - Số cuộc họp / tháng.
   * - Gói thường: Số cuộc họp đồng thời, Số người tham gia / CH.
   * - Gói Pool: Phân loại Pool, Giới hạn người tham gia Pool.
   * - Thời lượng tối đa / cuộc họp.
   */
  getTooltip(sub) {
    if (!sub) return "";
    const unitKey = sub.unitTime ? (sub.unitTime.endsWith("s") ? sub.unitTime : `${sub.unitTime}s`) : "";
    const unitText = unitKey && this.$te(unitKey) ? this.$t(unitKey).toString() : (sub.unitTime || "");
    const priceText = `${this.formatCurrencyAmount(sub.price || 0)} VND / ${sub.numberOfDaysUsage || 0} ${unitText}`;

    const isPool = sub.managementType === ManagementType.CONCURRENT_PARTICIPANT_POOL;

    if (isPool) {
      const poolCount = sub.maxParticipantPool ?? 0;
      return [
        priceText,
        this.$t("displayActiveSubMeetingCount", { count: sub.numberOfMeetingsPerMonth ?? 0 }).toString(),
        this.$t("concurrentParticipantPoolOption").toString(),
        this.$t("displayActiveSubMaxParticipantsPool", { count: poolCount }).toString(),
        this.$t("displayActiveSubMaxMeetingLength", { count: sub.maximumLengthOfOneMeeting ?? 0 }).toString()
      ].join("<br/>");
    }

    return [
      priceText,
      this.$t("displayActiveSubMeetingCount", { count: sub.numberOfMeetingsPerMonth ?? 0 }).toString(),
      this.$t("displayActiveSubConcurrentMeetings", { count: sub.numberOfConcurrentMeetings ?? 0 }).toString(),
      this.$t("displayActiveSubMaxParticipants", { count: sub.maximumNumberOfParticipantsInMeeting ?? 0 }).toString(),
      this.$t("displayActiveSubMaxMeetingLength", { count: sub.maximumLengthOfOneMeeting ?? 0 }).toString()
    ].join("<br/>");
  }
}
</script>
